import { useState, useEffect } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography } from '@mui/material';

import moment from 'moment';

import { usePages } from '../hooks/usePages';

import { TablePaginationActions } from '../helpers/TablePaginationActions';

import { TablePaddingStyle, TableTheadStyle } from '../styles/TableStyle';

import { BuscarSentencias } from '../connections/sentencia/SentenciaConnection';

import { BuscarSentenciasProps } from '../interfaces/sentencia/SentenciaInterface';
import { BuscarExpedienteResponse } from '../interfaces/recepcion/ExpedienteInterface';

interface params {
    openDialog:             boolean;
    handleCloseDialog:      ()=> void;
    expediente:             BuscarExpedienteResponse;
    SeleccionarSentencia:  ( data : BuscarSentenciasProps ) => void;
}

export const DialogBuscarSentencia = ( { openDialog, handleCloseDialog, expediente, SeleccionarSentencia } : params ) => {

    const [rows, setRows] = useState<BuscarSentenciasProps[]>( [] );
  
    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages( 10 );

    const [loadingSearch, setLoadingSearch] = useState( false );

    const Seleccionar = ( data : BuscarSentenciasProps ) => {
        
        SeleccionarSentencia( data );
        CerrarDialog();

    }

    const CerrarDialog = () => {

        handleCloseDialog();
        
        setRows( [] );

    } 

    useEffect(() => {

        async function Obtener(){

            const { idExpediente } = expediente;

            setLoadingSearch( true );

            await BuscarSentencias( idExpediente ).then( response => {

                setTimeout(() => {
                
                    setRows( response );
                    
                    setLoadingSearch( false );

                }, 700);    

            });
        }       
        
        if( openDialog ){

            Obtener();

        }

    }, [ openDialog, expediente ]);

    return (
        <>
            <Dialog 
                fullWidth
                maxWidth='md' 
                open={ openDialog } 
            >
             
                <DialogTitle>Buscar sentencia</DialogTitle>
            
                <DialogContent>
                    
                    <Grid container spacing={3} style={{ marginTop: '1px' }}>         

                        <Grid size={{ xs: 12, md: 12 }} >                           

                            <TableContainer sx={{ borderRadius: 3 }} component={Paper}>
                        
                            <Table>

                                    <TableHead sx={{ ...TableTheadStyle }}>

                                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>  

                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'30%', fontWeight: 'bold' }}>Número de seguimiento</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'30%', fontWeight: 'bold' }}>Número de sentencia</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'30%', fontWeight: 'bold' }}>Fecha</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', fontWeight: 'bold' }}> </TableCell>
                                            
                                        </TableRow>

                                    </TableHead>

                                    <TableBody>

                                        {
                                            (
                                                rowsPerPage > 0
                                                ? 
                                                    rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : 
                                                    rows
                                            ).map( ( row, index ) => {

                                                const { numeroSeguimiento, numeroSentencia, fecha, tipoSentencia } = row;

                                                return <TableRow key={ index }>

                                                    <TableCell> 
                                                        
                                                        <Typography variant='h6' fontWeight={'bold'}>
                                                            { numeroSeguimiento }                                                     
                                                        </Typography> 

                                                    </TableCell>
                                                    
                                                    <TableCell> 
                                                        
                                                        <Typography variant='h6' fontWeight={'bold'}>
                                                            { numeroSentencia }                                                     
                                                        </Typography> 

                                                        {
                                                            tipoSentencia
                                                            &&
                                                                <Typography variant='subtitle2' mt={1}>
                                                                    <strong>Tipo de sentencia:</strong> <br /> { tipoSentencia }                                                    
                                                                </Typography>                                                 
                                                        }    

                                                    </TableCell>
                                                    
                                                    <TableCell> { fecha ? moment( fecha ).format( 'DD-MM-YYYY' ) : '' } </TableCell>
                                                    
                                                    <TableCell> 

                                                        <Button 
                                                            size="small"
                                                            variant="contained"
                                                            sx={{ fontSize: 12 }}
                                                            onClick={ () => Seleccionar( row ) }
                                                        >
                                                            Seleccionar
                                                        </Button>

                                                    </TableCell>

                                                </TableRow>

                                            })
                                        }

                                        {
                                            rows.length === 0 
                                            &&
                                                <TableRow>

                                                    <TableCell
                                                        colSpan={9}
                                                        align="center"
                                                    >

                                                        {
                                                            loadingSearch
                                                            ?
                                                                <Typography variant="caption" color='secondary'> Buscando.... </Typography>
                                                            :
                                                                <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                                        }

                                                    </TableCell>

                                                </TableRow>      
                                        }

                                    </TableBody>

                                    <TableFooter>

                                        <TableRow>
                                            
                                            <TablePagination
                                                rowsPerPageOptions={[ 5, 10, 25 ]}
                                                colSpan={ 4 }
                                                count={ rows.length }
                                                rowsPerPage={ rowsPerPage }
                                                page={ page }
                                                onPageChange={ handleChangePage }
                                                onRowsPerPageChange={ handleChangeRowsPerPage }
                                                ActionsComponent={ TablePaginationActions }

                                                labelDisplayedRows={
                                                    ({ from, to, count }) => {
                                                      return '' + from + '-' + to + ' de ' + count
                                                    }
                                                }
                                            />

                                        </TableRow>

                                    </TableFooter>

                                </Table>
                            
                            </TableContainer>

                        </Grid>           
                        
                    </Grid>
                    
                </DialogContent>

                <DialogActions>
                    <Button onClick={ handleCloseDialog }>Cancelar</Button>
                </DialogActions>

            </Dialog>
        </>
    )
}
